module.exports = __webpack_public_path__ + "img/015.363cda8c.jpg";